import { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar } from 'recharts';
// import { BarChart, Bar,  XAxis, YAxis, CartesianGrid } from 'recharts';
import { Users, TrendingUp, Phone } from 'lucide-react';
// import { LineChart, Line, Legend } from 'recharts';
import { useReports } from '../../hooks/useReports';
// import { FunnelChart, Funnel, LabelList } from 'recharts';




const COLORS = ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4'];

export default function Dashboard() {
  // const [data, setData] = useState<DashboardData>(mockData);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('2025-10-01');
  const [endDate, setEndDate] = useState('2025-10-31');
  const [selectedAgent, setSelectedAgent] = useState<string>("");
  // const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  // const [showAgentDropdown, setShowAgentDropdown] = useState(false);
  // const [showStatusDropdown, setShowStatusDropdown] = useState(false);

  const { dataTotal, dataLeads, dataSource, dataActivity, dataProgram, dataStatus, dataUsers } = useReports({ start_date: startDate, end_date: endDate, user_id: selectedAgent });


  // Función para cargar datos del backend
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
    } catch (error) {
      console.error('Error:', error);
      // setData(mockData);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-xl text-gray-600">Cargando datos...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen  p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-300 mb-2">Dashboard de Rendimiento</h1>
          <p className="text-gray-600 dark:text-gray-400">Análisis de Leads</p>
        </div>

        {/* Filters Section */}
        <div className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-8">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-300 mb-4">Filtros</h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-gray-700 dark:text-gray-300">

            <div>
              <label className="block text-sm font-medium mb-2">Fecha Inicio</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium  mb-2">Fecha Fin</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium  mb-2">
                Seleccionar Agente
              </label>
              <select
                value={selectedAgent}
                onChange={(e) => setSelectedAgent(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Todos los agentes</option>
                {dataUsers.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.full_name}
                  </option>
                ))}
              </select>
            </div>


            {/* <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2">Agentes</label>
              <button
                onClick={() => setShowAgentDropdown(!showAgentDropdown)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-between"
              >
                <span className="text-gray-700">
                  {selectedAgents.length === 0
                    ? 'Todos los agentes'
                    : `${selectedAgents.length} seleccionado(s)`}
                </span>
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {showAgentDropdown && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                  {data.agents.map((agent) => (
                    <label
                      key={agent.id}
                      className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={selectedAgents.includes(agent.id)}
                        onChange={() => handleAgentToggle(agent.id)}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="text-gray-700">{agent.name}</span>
                    </label>
                  ))}
                </div>
              )}
            </div> */}


            {/* <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
              <button
                onClick={() => setShowStatusDropdown(!showStatusDropdown)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-between"
              >
                <span className="text-gray-700">
                  {selectedStatuses.length === 0
                    ? 'Todos los status'
                    : `${selectedStatuses.length} seleccionado(s)`}
                </span>
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {showStatusDropdown && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                  {data.availableStatuses.map((status) => (
                    <label
                      key={status}
                      className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={selectedStatuses.includes(status)}
                        onChange={() => handleStatusToggle(status)}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="text-gray-700">{status}</span>
                    </label>
                  ))}
                </div>
              )}
            </div> */}
          </div>


          {/* <div className="flex items-center gap-3 mt-4">
            <button
              onClick={applyFilters}
              className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
            >
              Aplicar Filtros
            </button>
            <button
              onClick={clearFilters}
              className="px-6 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors"
            >
              Limpiar Filtros
            </button>
            {(selectedAgents.length > 0 || selectedStatuses.length > 0) && (
              <span className="text-sm text-gray-600">
                Filtros activos: {[
                  selectedAgents.length > 0 && `${selectedAgents.length} agente(s)`,
                  selectedStatuses.length > 0 && `${selectedStatuses.length} status`
                ].filter(Boolean).join(', ')}
              </span>
            )}
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Total Leads</p>
                <p className="text-2xl font-bold text-gray-900">{dataTotal?.total_leads ? dataTotal.total_leads : 0}</p>
              </div>
              <Users className="w-10 h-10 text-primary" />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Contactados</p>
                <p className="text-2xl font-bold text-gray-900">{dataTotal?.contactados ? dataTotal.contactados : 0}</p>
              </div>
              <Phone className="w-10 h-10 text-primary" />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Inscritos</p>
                <p className="text-2xl font-bold text-gray-900">{dataTotal?.inscritos ? dataTotal.inscritos : 0}</p>
              </div>
              <TrendingUp className="w-10 h-10 text-primary" />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Tasa de Conversión</p>
                <p className="text-2xl font-bold text-gray-900">{dataTotal?.conversion_rate ? dataTotal.conversion_rate : 0}%</p>
              </div>
              <TrendingUp className="w-10 h-10 text-primary" />
            </div>
          </div>
        </div>

        {/* Funnel Chart - Lo más importante */}
        {/* <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Embudo de Conversión por Etapa</h2>
          <p className="text-sm text-gray-600 mb-6">Visualiza dónde se están quedando los leads en el proceso</p>
          <ResponsiveContainer width="100%" height={400}>
            <FunnelChart>
              <Tooltip />
              <Funnel dataKey="value" data={data.funnelData} isAnimationActive>
                <LabelList position="right" fill="#000" stroke="none" dataKey="stage" />
                <LabelList position="inside" fill="#fff" stroke="none" dataKey="value" />
              </Funnel>
            </FunnelChart>
          </ResponsiveContainer>
        </div> */}




        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Leads por status</h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-6">
              {/* Gráfico */}
              <div className="flex-1 w-full">
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={dataStatus}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="count"
                    >
                      {dataStatus.map((entry, index) => (
                        <Cell
                          key={`cell-${index}-${entry.status_id}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value: string) => [
                        `${value} `
                      ]}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* Leyenda personalizada */}
              <div className="flex flex-col gap-2 lg:w-1/3">
                {dataStatus.map((entry, index) => (
                  <div
                    key={`legend-${entry.status_id}`}
                    className="flex items-center gap-2 text-xs"
                  >
                    <div
                      className="w-4 h-4 rounded flex-shrink-0"
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    />
                    <span className="text-gray-700">
                      {entry.status_name}: <span className="font-semibold">{entry.count}</span> ({entry.percentage}%)
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Fuentes de Leads</h2>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={dataSource} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="source_name" type="category" width={100} />
                <Tooltip />
                <Bar dataKey="lead_count" fill="#3b82f6">
                  {dataSource.map((entry, index) => (
                    <Cell key={`cell-${index}-${entry.source_id}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>


          {/* <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Programas de Interés</h2>
              {selectedStatuses.length > 0 && (
                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                  Filtrado por status
                </span>
              )}
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data.programInterest}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="program" angle={-45} textAnchor="end" height={100} />
                <YAxis />
                <Tooltip />
                <Bar dataKey="count" fill="#8b5cf6" />
              </BarChart>
            </ResponsiveContainer>
          </div> */}

          {/* <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Distribución por Ciudad</h2>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data.cityDistribution} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="city" type="category" width={100} />
                <Tooltip />
                <Bar dataKey="count" fill="#3b82f6" />
              </BarChart>
            </ResponsiveContainer>
          </div> */}

          {/* <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Distribución por Status</h2>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={data.statusDistribution}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="status" angle={-45} textAnchor="end" height={80} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="count" stroke="#10b981" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div> */}
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Programa de Interés</h2>
              <span className="text-sm text-gray-500">
                Total: {dataProgram.reduce((sum, item) => sum + parseInt(item.lead_count), 0)} leads
              </span>
            </div>
            <ResponsiveContainer width="100%" height={Math.max(300, dataProgram.length * 30)}>
              <BarChart data={dataProgram} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis
                  dataKey="programa_de_interes"
                  type="category"
                  width={200}
                  tick={{ fontSize: 12 }}
                  tickFormatter={(value) => {
                    const maxLength = 28;
                    return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                  }}
                />
                <Tooltip
                  formatter={(value) => [`${value} leads`, 'Cantidad']}
                  labelFormatter={(label) => label}
                  contentStyle={{ fontSize: '14px' }}
                />
                <Bar dataKey="lead_count" fill="#3b82f6" radius={[0, 8, 8, 0]}>
                  {dataProgram.map((entry, index) => (
                    <Cell
                      key={`cell-${index}-${entry.programa_de_interes}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Stage Flow Analysis */}
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Detalle de Actividades por Agente</h2>
          <div className="space-y-6">
            {dataActivity.map((activity, idx) => (
              <div key={idx} className="border-l-4 border-blue-500 pl-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-lg text-gray-800">{activity.user_name}</h3>
                  <span className="text-sm font-medium text-gray-600">Total: {activity.total_activities}</span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {activity.activities_by_type.map((type, i) => (
                    <div key={i} className="bg-gray-50 rounded p-3">
                      <p className="text-xs text-gray-600">{type.type_name}</p>
                      <p className="text-lg font-semibold text-gray-900">{type.count}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stage Flow Analysis */}
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Flujo Detallado por Etapa y Status</h2>
          <div className="space-y-6">
            {dataLeads.map((stage, idx) => (
              <div key={idx} className="border-l-4 border-blue-500 pl-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-lg text-gray-800">{stage.process_name}</h3>
                  <span className="text-sm font-medium text-gray-600">Total: {stage.total_leads_in_process}</span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {stage.statuses.map((status, i) => (
                    <div key={i} className="bg-gray-50 rounded p-3">
                      <p className="text-xs text-gray-600">{status.status_name}</p>
                      <p className="text-lg font-semibold text-gray-900">{status.lead_count}</p>
                      <p className="text-xs text-gray-500">
                        {status.percentage_of_process} %
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>


        {/* Insights Alert */}
        {/* <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg">
          <div className="flex items-start">
            <AlertCircle className="w-6 h-6 text-yellow-600 mr-3 mt-0.5" />
            <div>
              <h3 className="text-lg font-semibold text-yellow-800 mb-2">Insights del Mes</h3>
              <ul className="list-disc list-inside text-yellow-700 space-y-1">
                <li>Mayor pérdida de leads en la etapa de Calificación (33% de abandono)</li>
                <li>Facebook es la principal fuente de leads con 40% del total</li>
                <li>Quito concentra el 40% de los leads potenciales</li>
                <li>La tasa de conversión de Negociación a Cierre es del 94%</li>
              </ul>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}